import React, { useState } from 'react';
import _get from 'lodash/get';
import { connect } from 'react-redux';
import { arrayOf, object } from 'prop-types';
import classNames from 'classnames/bind';
import Tooltip from 'yoda-site-components/lib/components/YodaTooltip/YodaTooltip';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { isDesktopWidth, isTabletWidth } from 'yoda-core-components/lib/helpers/Utils/mediaQuery';
import Slider from 'yoda-core-components/lib/components/Slider/Slider';
import Carousel from 'yoda-site-components/lib/components/Carousel';
import { getImageSrc } from 'yoda-core-components/lib/helpers/AssetUtils';
import { getPageURLFromAPIURL, updateQueryStringParameter } from '../../utils';
import * as styles from './VisualRelatedSearch.css';

const cx = classNames.bind(styles);

export const VisualRelatedSearch = ({ relatedSearchReducer }) => {
    const [imageHeight, setImageHeight] = useState(0);
    /* istanbul ignore next */
    if (!(relatedSearchReducer || []).length) return null;

    const products = relatedSearchReducer.filter((product) => product.productImgId);
    /* istanbul ignore next */
    const renderRelatedSearchLinks = (product, index) => {
        const { apiUrl = '', productImgId = '', text = '', sourceType = null } = product;
        const relatedSearchUrl = updateQueryStringParameter(
            getPageURLFromAPIURL(apiUrl),
            'searchType',
            'Related Search Term'
        );

        const visualSearchImage = dt([
            'block',
            'border',
            'border-gray-15',
            'border-solid',
            'mx-auto',
            'my-0',
            'rounded-full',
        ]);

        const searchProdName = dt([
            'font-open-sans',
            'mt-1',
            'no-underline',
            'text-center',
            'text-black',
            'text-small',
            'whitespace-normal',
            'pt-1',
            'pb-1',
        ]);

        const searchLink = `${dt(['inline-block', 'no-underline', 'text-small'])} ${cx(
            'searchLink'
        )}`;

        const searchToolTip = dt([
            'bg-white',
            'border-0',
            'py-2',
            'pr-2',
            'pl-1',
            'rounded-md',
            'shadow-elevation2',
            'bottom-10',
            'right-0',
            'text-center',
            'after:hidden',
        ]);

        const searchTextEllipsis = dt(['max-h-16', 'h-auto', 'overflow-hidden']);

        return (
            <a href={relatedSearchUrl} className={searchLink}>
                <img
                    alt={text}
                    className={visualSearchImage}
                    src={getImageSrc(productImgId, {}, { context: 'thumbnail', sourceType })}
                    onLoad={
                        index === 0 ? ({ target }) => setImageHeight(target?.offsetHeight) : null
                    }
                />
                {text.length > 28 ? (
                    <Tooltip
                        automationId="visual-related-search"
                        direction="Topright"
                        renderTooltipContents={text}
                        tooltipContentClass={searchToolTip}
                        tooltipPlacement="Right"
                        triggerEventName="mouseover"
                    >
                        <h4
                            className={`${cx(
                                searchProdName,
                                'searchTextEllipsis'
                            )} ${searchTextEllipsis}`}
                        >
                            {text}
                        </h4>
                    </Tooltip>
                ) : (
                    <h4 className={cx(searchProdName)}>{text}</h4>
                )}
            </a>
        );
    };

    const carouselItemList = (dataItem) => {
        const arrdata = dataItem.map((item, index) => {
            return renderRelatedSearchLinks(item, index);
        });
        return arrdata;
    };

    const carouselTheme = (dataItems) => {
        const dataLength = dataItems?.length;
        const isSectionJustifyBetween =
            (isTabletWidth() && dataLength === 5) ||
            (isDesktopWidth() && (dataLength === 6 || dataLength === 7));
        const isSectionJustifyCenter =
            (isTabletWidth() && dataLength <= 4) || (isDesktopWidth() && dataLength <= 5);
        /* istanbul ignore next */
        if (isSectionJustifyBetween) {
            return 'dyanmic-rel-visNav-carousel-even';
        }
        if (isSectionJustifyCenter) {
            return 'dynamic-rel-visNav-carousel-center';
        }

        return 'dynamic-rel-visNav-carousel';
    };

    const renderRelatedSearchList = () => {
        return (
            <Carousel
                theme={carouselTheme(products)}
                automationId="relvisnavCarousel"
                automationItemId="rel-viz-nav-carousel"
                children={carouselItemList(products)}
                carouselImageHeight={imageHeight}
            />
        );
    };

    return (
        <article
            className={`${dt(['border-y', 'border-gray-15', 'border-solid', 'py-2', 'mb-6'])} ${cx(
                'relatedSearchWrapper'
            )}`}
            data-automation-id="releatedguides"
        >
            <h3
                className={dt([
                    'font-open-sans-bold',
                    'text-center',
                    'text-black',
                    'text-medium',
                    'py-2',
                ])}
            >
                Related To Your Search
            </h3>
            <section
                className={`${dt(['py-2', 'overflow-hidden', 'smMd:-mx-6'])} ${cx('resultSet')}`}
            >
                <Slider contentWrapperClass="visualRelatedContentWrapper">
                    {renderRelatedSearchList()}
                </Slider>
            </section>
        </article>
    );
};

VisualRelatedSearch.propTypes = {
    relatedSearchReducer: arrayOf(object).isRequired,
};

const mapStateToProps = (state) => ({
    relatedSearchReducer: _get(state, 'relatedSearchReducer', []),
});

export default connect(mapStateToProps)(VisualRelatedSearch);
